import { useCallback, useEffect, useRef, useState, type FocusEvent, type FormEvent } from 'react'

export const MENSAGEM_NCM_INEXISTENTE = 'Código não existe na tabela oficial de NCM'

const ATRASO_FECHAMENTO_SELECT_MS = 350

export function useNcmTextoPendente() {
  const [texto, setTexto] = useState('')
  const [exibirErro, setExibirErro] = useState(false)
  const temporizador = useRef<ReturnType<typeof setTimeout> | null>(null)

  const cancelarTemporizador = useCallback(() => {
    if (temporizador.current !== null) {
      clearTimeout(temporizador.current)
      temporizador.current = null
    }
  }, [])

  useEffect(() => cancelarTemporizador, [cancelarTemporizador])

  const aoDigitar = useCallback(
    (event: FormEvent<HTMLElement>) => {
      const alvo = event.target
      if (alvo instanceof HTMLInputElement) {
        cancelarTemporizador()
        setTexto(alvo.value)
        setExibirErro(false)
      }
    },
    [cancelarTemporizador],
  )

  const aoSair = useCallback(
    (event: FocusEvent<HTMLElement>) => {
      const campo = event.currentTarget.querySelector('input')
      if (!campo) return
      cancelarTemporizador()
      temporizador.current = setTimeout(() => {
        temporizador.current = null
        if (document.activeElement === campo) return
        setTexto(anterior => (campo.value === anterior ? anterior : ''))
      }, ATRASO_FECHAMENTO_SELECT_MS)
    },
    [cancelarTemporizador],
  )

  const limpar = useCallback(() => {
    cancelarTemporizador()
    setTexto('')
    setExibirErro(false)
  }, [cancelarTemporizador])

  const pendente = texto.trim() !== ''

  const bloquear = useCallback((): boolean => {
    if (texto.trim() === '') return false
    setExibirErro(true)
    return true
  }, [texto])

  return { pendente, exibirErro, aoDigitar, aoSair, limpar, bloquear }
}
